module.exports = __webpack_public_path__ + "img/puzzle6_3.76e05f23.jpg";